import { useSelector } from "react-redux";
import moment from "moment";
import { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import { Icon } from "components";
import { getArtieLogo, getIsMaximized, selectPropertyId } from "slices";
import { renderMascot } from "utils";

const ConfirmedTourForm = ({ isLastBot, staticImageData, isUserMsg, position, mascotSettings, customSize, message }) => {
  const artieLogo = useSelector(getArtieLogo);
  const propertyId = useSelector(selectPropertyId);
  const isMaximized = useSelector(getIsMaximized);

  const [bookingDetails, setBookingDetails] = useState(null);

  useEffect(() => {
    if (!propertyId) {
      return;
    }

    try {
      const data = localStorage.getItem(`${propertyId}-booking_details`);

      if (data) {
        const parsed = JSON.parse(data);
        setBookingDetails(parsed);
      }
    } catch (error) {
      console.error("Error parsing booking details from localStorage:", error);
    }
  }, [propertyId]);

  const formatBookingDate = (input) => {
    const date = moment.parseZone(input); // preserves the original timezone
    const now = moment();

    if (date.isSame(now, "day")) {
      return `Today, ${date.format("h:mm A")}`;
    }

    if (date.isSame(moment().add(1, "day"), "day")) {
      return `Tomorrow, ${date.format("h:mm A")}`;
    }

    return date.format("MMMM D, YYYY, h:mm A");
  };

  // console.log("bookingDetails", bookingDetails);

  if (!bookingDetails) {
    return null;
  }

  return (
    <div style={{ overflowWrap: "break-word" }}>
      <div className={`hayley-flex ${isLastBot && (isMaximized ? "hayley-mb-4" : "hayley-mb-3")}`}>
        {isUserMsg ? (
          isMaximized ? (
            <Icon iconType="DefaultUser" classes={"hayley-h-9 hayley-w-9 hayley-object-cover"} />
          ) : (
            ""
          )
        ) : (
          <>
            {isEmpty(artieLogo) && <div className="hayley-h-9 hayley-w-9">{renderMascot(mascotSettings, position, true, customSize, false)}</div>}

            {!isEmpty(artieLogo) && (
              <div className="hayley-z-10 hayley-flex hayley-h-9 hayley-w-9 hayley-items-center hayley-justify-center hayley-rounded-full hayley-border hayley-border-[#EEE]">
                <img
                  id="staticImage"
                  src={artieLogo.includes("data:image/gif") ? staticImageData : artieLogo}
                  alt=""
                  className={`hayley-h-8 hayley-w-8 hayley-rounded-full hayley-object-cover`}
                />
              </div>
            )}
          </>
        )}
        <div className="hayley-mx-3">
          <div className="hayley-max-w-[725px] hayley-rounded-lg hayley-rounded-tl-none hayley-bg-custom-7 !hayley-px-4 !hayley-py-2 hayley-text-sm hayley-text-secondary">
            {/* {follow_up?.tour_not_scheduled?.text.length > 0 ? follow_up?.tour_not_scheduled?.text : t("wouldYouSchedule")} */}
            {message ?? ""}
          </div>
        </div>
      </div>
      <div className={`hayley-mt-4 ${isMaximized ? "hayley-w-[420px]" : "hayley-w-full"} hayley-rounded-md`} style={{ border: "1px solid #66D18433" }}>
        {/* Header */}
        <div className="hayley-flex hayley-h-[48px] hayley-items-center hayley-justify-center hayley-bg-[#66D18408]">
          <p className="hayley-text-[16px] hayley-font-bold hayley-text-[#66D184]">Confirmed Tour</p>
        </div>
        <div className="hayley-px-2">
          {/* Tour Type & Time */}
          <div className="hayley-flex hayley-items-center hayley-justify-center hayley-space-x-6">
            {/* In-Person Tour */}
            <div className="hayley-flex hayley-items-center hayley-space-x-2">
              <Icon iconType="PersonIcon" />
              <p className="hayley-text-[16px] hayley-font-semibold hayley-text-[#333333]">{bookingDetails?.appointmentType ?? ""}</p>
            </div>

            {/* Date & Time */}
            <div className="hayley-flex hayley-items-center hayley-space-x-2">
              <Icon iconType="CheckedCalendar" />
              <p className="hayley-text-[16px] hayley-font-semibold hayley-text-[#333333]">{formatBookingDate(bookingDetails?.start_at) || ""}</p>
            </div>
          </div>

          {/* Location */}
          {/* <div className="hayley-flex hayley-justify-center hayley-items-center hayley-px-4 hayley-py-2">
            <div className="hayley-mr-2 hayley-flex-shrink-0 hayley-flex hayley-justify-center hayley-items-center">
              <Icon iconType="locationPinIcon" className="hayley-h-5 hayley-w-5" />
            </div>

            <div className="hayley-flex hayley-items-center hayley-text-sm hayley-font-[400] hayley-text-[#333333]">
              Central Ave, St. Petersburg, FL, 33705&nbsp;
              <span className="hayley-ml-1 hayley-inline-flex hayley-h-5 hayley-w-5 hayley-flex-shrink-0 hayley-items-center">
                <Icon iconType="gpsIcon" className="hayley-h-full hayley-w-full" />
              </span>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ConfirmedTourForm;
